import React from "react";
import PropTypes from "prop-types";

import publicLogo from "assets/logo/logo.svg";
import privateLogo from "assets/logo/logoPrivate.svg";
import g4rLogo from "assets/logo/g4r_logo.svg";
import goway from "assets/logo/Goway_main.svg";
import smeb from "assets/logo/SMEB_colour.svg";
import smeGo from "assets/logo/smeGo_color.svg";

const logoList = {
  smeWhite: publicLogo,
  smeBlue: privateLogo,
  go4rent: g4rLogo,
  smeb: smeb,
  goway: goway,
  smeGo: smeGo,

};

const Logo = ({ type, responsive }) => {
  return <img src={logoList[type]} alt="logo" className={`logo ${responsive ? "logo--responsive" : ""}`} />;
};

Logo.propTypes = {
  type: PropTypes.oneOf(Object.keys(logoList)),
};

Logo.defaultProps = {
  type: "smeBlue",
};

export default Logo;
